import { Link, useParams, Navigate } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { findInsight, INSIGHTS } from "../lib/insights";
import { ConsultationDialog } from "../components/ConsultationDialog";

export default function InsightDetailPage() {
  const { slug } = useParams();
  const post = findInsight(slug);
  if (!post) return <Navigate to="/insights" replace />;
  const others = INSIGHTS.filter((p) => p.slug !== slug).slice(0, 2);

  return (
    <main data-testid="insight-detail-page" className="pt-32">
      <section className="pb-12">
        <div className="container-myc">
          <Link
            to="/insights"
            data-testid="back-to-insights-link"
            className="inline-flex items-center gap-2 text-slate-600/60 hover:text-[#7A1F26] text-sm"
          >
            <ArrowLeft className="w-4 h-4" /> Back to insights
          </Link>
        </div>
      </section>

      <article className="pb-20">
        <div className="container-myc max-w-3xl">
          <div className="flex items-center justify-between text-xs tracking-widest uppercase mb-7">
            <span className="text-[#7A1F26]">{post.category}</span>
            <span className="text-slate-600/40">
              {post.date} · {post.readTime}
            </span>
          </div>
          <h1 className="h-display-1 text-[#2A0A0E]">{post.title}</h1>
          <div className="gold-line my-12" />
          <div className="space-y-6 text-slate-600/75 text-lg leading-[1.8] font-display-x">
            {post.content.map((para, i) => (
              <p key={i}>{para}</p>
            ))}
          </div>
        </div>
      </article>

      <section className="py-20 bg-[#FAF5EB]">
        <div className="container-myc max-w-4xl text-center">
          <p className="eyebrow">Discuss this further</p>
          <h2 className="h-display-3 text-[#2A0A0E] mt-3">
            Apply this thinking to your portfolio.
          </h2>
          <p className="text-slate-600/65 mt-5 max-w-xl mx-auto">
            A 30-minute conversation with a senior advisor — confidential and
            without obligation.
          </p>
          <div className="mt-8">
            <ConsultationDialog
              trigger={
                <button data-testid="insight-cta-consult-button" className="btn-gold">
                  Book a Consultation <ArrowRight className="w-4 h-4" />
                </button>
              }
            />
          </div>
        </div>
      </section>

      <section className="py-20">
        <div className="container-myc">
          <p className="eyebrow">Continue reading</p>
          <div className="grid md:grid-cols-2 gap-px bg-slate-900/5 border border-slate-200/5 mt-8">
            {others.map((p) => (
              <Link
                key={p.slug}
                to={`/insights/${p.slug}`}
                className="bg-[#FAF5EB] hover:bg-[#FAF5EB] p-7 transition-colors group"
              >
                <span className="text-xs text-[#7A1F26] tracking-widest uppercase">
                  {p.category}
                </span>
                <h3 className="font-display text-xl text-[#2A0A0E] mt-3 group-hover:text-[#7A1F26] transition-colors">
                  {p.title}
                </h3>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
